import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ExpenseTypeDetails = (props) => {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  // Extract the expenseType data from the location state
  const { expenseType } = props.location.state;

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto mt-8 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold">Expense Type Details</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 mr-3 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={() => history.goBack()}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Expense Type"
                ></i>
              </button>
            </div>
          </div>
          <div>
            <div>
              <strong>Expense Type Name:</strong> {expenseType.expenseTypeName}
            </div>
            <div>
              <strong>Default Text:</strong> {expenseType.defaulttext}
            </div>
            <div>
              <strong>Type:</strong> {expenseType.type}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExpenseTypeDetails;
